import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './common/header/header.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { LoginOpt, SocialLoginModule } from 'angularx-social-login';
import { AuthServiceConfig, GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';
import { PetsComponent } from './pets/pets.component';
import { SidebarModule } from 'ng-sidebar';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDatepickerModule, MatInputModule, MatNativeDateModule, MatIconModule, MatCheckboxModule, MatTabsModule } from '@angular/material';
import { ThanksComponent } from './pets/thanks/thanks.component';
import { CommonComponent } from './common/common.component';
import { ReportComponent } from './pets/report/report.component';
import { ReportLostComponent } from './pets/report/lost/lost.component';
import { ReportFoundComponent } from './pets/report/found/found.component';

import { FoundPersonalinfoComponent } from './pets/report/found/personalinfo/personalinfo.component';
import { FoundPetinfoComponent } from './pets/report/found/petinfo/petinfo.component';
import { LostPetinfoComponent } from './pets/report/lost/petinfo/petinfo.component';
import { LostPersonalinfoComponent } from './pets/report/lost/personalinfo/personalinfo.component';

import { ListComponent } from './pets/list/list.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { DatePipe } from '@angular/common';
import { LostPetListComponent } from './pets/report/lost/petlist/petlist.component';
import { DialogComponent } from './pets/dialog/dialog.component';
import { StaticpagesComponent } from './staticpages/staticpages.component';
import { DetailComponent } from './pets/detail/detail.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxPaginationModule } from 'ngx-pagination'; // <-- import the module
import { Ng5SliderModule } from 'ng5-slider';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { NgxSpinnerModule } from "ngx-spinner";
import { ShareModule } from '@ngx-share/core';
import { UpdatepetinfoComponent } from './pets/updatepetinfo/updatepetinfo.component';
import { CompanyUserLoginComponent } from './company-user-login/company-user-login.component';
//import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import * as Hammer from 'hammerjs';
import { FacebookModule } from 'ngx-facebook';
import { NgxMatDateFormats, NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule, NGX_MAT_DATE_FORMATS, NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { QRCodeModule } from 'angularx-qrcode';
import { CustomNgxDatetimeAdapter } from './CustomNgxDatetimeAdapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
///import {NgxMatMomentModule, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular-material-components/moment-adapter';
import { Home2Component } from './Home2/home2/home2.component';
import { SearchComponent } from './search-pets/search/search.component';
import { Details2Component } from './Details2/details2/details2.component';
import { UserComponent } from './CreateUser/user/user.component';
import { SearchPage } from './search-page/search-page.component';
import { PrivacyComponentComponent } from './dialog/PrivacyDialog/privacy-component/privacy-component.component';
import { MinsideAuthCallbackComponent } from './minside-auth-callback/minside-auth-callback.component';
import { ExtendReminderComponent } from './extend-reminder/extend-reminder.component';
import { OTPloginComponent } from './otplogin/otplogin.component';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDialogModule } from '@angular/material/dialog';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ErrorpageComponent } from './errorpage/errorpage.component';
// import { ShareIconsModule } from 'ngx-sharebuttons/icons';

export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any>{
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}
const fbLoginOptions: LoginOpt = {
  scope: 'publish_to_groups,pages_manage_posts,pages_show_list,pages_read_engagement,email',
  return_scopes: true,
  enable_profile_selector: true
};
const config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    //provider: new GoogleLoginProvider('58407131780-ddtlfh64tcp0pfnmrlch9kkbel4qioko.apps.googleusercontent.com')
    provider: new GoogleLoginProvider('334817837812-hg5ds91ufkuucocgrb4j4n2fl32qn7fv.apps.googleusercontent.com')
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider('4564510300250066',fbLoginOptions)
  },
]);

const CUSTOM_DATE_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: 'l, LTS'
  },
  display: {
    dateInput: 'DD/MM/YYYY HH:mm:ss',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};

export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
    HomeComponent,
    PetsComponent,
    ThanksComponent,
    FoundPersonalinfoComponent,
    FoundPetinfoComponent,
    CommonComponent,
    ReportComponent,
    ReportLostComponent,
    ReportFoundComponent,
    LostPetinfoComponent,
    LostPersonalinfoComponent,
    ListComponent,
    DashboardComponent,
    LostPetListComponent,
    DialogComponent,
    StaticpagesComponent,
    DetailComponent,
    UserProfileComponent,
    UpdatepetinfoComponent,
    CompanyUserLoginComponent,
    Home2Component,
    SearchComponent,
    Details2Component,
    UserComponent,
    SearchPage,
    PrivacyComponentComponent,
    MinsideAuthCallbackComponent,
    ExtendReminderComponent,
    OTPloginComponent,
    ErrorpageComponent
  ],
  imports: [
    BrowserModule,
    HammerModule,
    AppRoutingModule,
    NgbModule,
    SocialLoginModule,
    FormsModule,
    ReactiveFormsModule,
    SidebarModule.forRoot(),
    FacebookModule.forRoot(),
    HttpClientModule,
    NgSelectModule,
    NgxSpinnerModule,
    QRCodeModule,
    MatTabsModule,
    MatDialogModule, MatInputModule, MatButtonModule, MatCardModule, MatFormFieldModule,
    AgmCoreModule.forRoot({
      // apiKey: 'AIzaSyDGrBJEQfuafRoEsikREQGC-_b7-FrBzmY',
      apiKey: 'AIzaSyAwPSO-mBtpejXNBdwchOOo8L3NDeyaZmw',
      libraries: ['places']
    }),
    AgmJsMarkerClustererModule,
    BrowserAnimationsModule,
    MatDatepickerModule, MatInputModule, MatNativeDateModule, MatIconModule, MatCheckboxModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    NgxPaginationModule,
    Ng5SliderModule,
    ImageCropperModule,
    BreadcrumbModule,
    ShareModule,
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    // ShareButtonsModule,
    NgxCaptchaModule
    // ShareIconsModule
    //InfiniteScrollModule
  ],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig,
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig,
    },
    {
      provide: NGX_MAT_DATE_FORMATS,
      useValue: CUSTOM_DATE_FORMATS
    },
    {
      provide: NgxMatDateAdapter,
      useClass: CustomNgxDatetimeAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    [DatePipe]
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function httpTranslateLoader(http: HttpClient) {
  //return new TranslateHttpLoader(http);
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
export class CustomNgxDateTimeModule { }